import Swal from 'sweetalert2'

export default defineNuxtPlugin(() => {
  const router = useRouter()

  router.beforeEach(() => {
    Swal.close()
    return true
  })
})
